function Hungary({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1360)">
        <path d="M0.995188 10.4348C0.352063 12.1681 0 14.0428 0 16C0 17.9571 0.352063 19.8319 0.995188 21.5651L16 22.9565L31.0048 21.5651C31.6479 19.8319 32 17.9571 32 16C32 14.0428 31.6479 12.1681 31.0048 10.4348L16 9.04346L0.995188 10.4348Z" fill="#F0F0F0"/>
        <path d="M16 0C9.12061 0 3.25586 4.342 0.995239 10.4348H31.0049C28.7441 4.342 22.8795 0 16 0Z" fill="#D80027"/>
        <path d="M16 32.0002C22.8795 32.0002 28.7441 27.6582 31.0049 21.5654H0.995239C3.25586 27.6582 9.12061 32.0002 16 32.0002Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Hungary;
